import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {FaqSection, IFaqQuestion} from "@pg-mono/faq";
import {monthWhenVerbose, priceFormat, priceM2Format} from "@pg-mono/string-utils";

import {IRPStore} from "../../../../app/rp_reducer";
import {calculateAvgPrices} from "../../utils/calculate_avg_prices";
import {cityNameWhere, cityPronounWhere} from "../../utils/city_name_declination_utils";
import {getCitiesData} from "../../utils/get_cities_data";
import {calculatePercent, getPercentMeaning, getPercentMoreLess} from "../../utils/percents_handling_helpers";
import {PricesHubViewSectionTracker} from "./PricesHubViewSectionTracker";

// SEO manages the hub FAQ in admin (FAQ category assigned to this page's URL, fetched by fetchFaqListAtRoute),
// on top of the generic nationwide price questions also shown on the legacy general prices page.
export const PricesHubFaq = () => {
    const faq = useSelector((store: IRPStore) => store.faq.data);
    const citiesSummaryData = getCitiesData();

    const cheapestCities = citiesSummaryData && [...citiesSummaryData].sort((prev, next) => prev.avgPriceM2 - next.avgPriceM2);
    const expensiveCities = citiesSummaryData && [...citiesSummaryData].sort((prev, next) => next.avgPriceM2 - prev.avgPriceM2);
    const date = new Date((citiesSummaryData && citiesSummaryData[0].date) || "");
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const {generalAvgPrice, generalAvgM2Price, generalOldAvgPrice, generalOldAvgM2Price} = calculateAvgPrices(citiesSummaryData);
    const priceM2Percent = calculatePercent(generalOldAvgM2Price, generalAvgM2Price);
    const pricePercent = calculatePercent(generalOldAvgPrice, generalAvgPrice);

    const answers = [
        `W ${monthWhenVerbose(month)} ${year} średnia cena za m² wynosi ${priceM2Format(generalAvgM2Price)}. To o ${Math.abs(priceM2Percent)}% ${getPercentMoreLess(priceM2Percent)} niż w ubiegłym roku. Średnia ofertowa cena mieszkania w Polsce wynosi aktualnie ${priceFormat(generalAvgPrice)}, to oznacza ${getPercentMeaning(pricePercent)} o ${Math.abs(pricePercent)}% rok do roku.`,
        cheapestCities
            ? `Patrząc na miasta wojewódzkie, najtańsze mieszkania znajdziemy ${cityPronounWhere(cheapestCities[0].city)} ${cityNameWhere(cheapestCities[0].city)}, ${cityNameWhere(cheapestCities[1].city)} i ${cityNameWhere(cheapestCities[2].city)}. Ceny mieszkań wynoszą tu odpowiednio ${priceM2Format(cheapestCities[0].avgPriceM2)}, ${priceM2Format(cheapestCities[1].avgPriceM2)} oraz ${priceM2Format(cheapestCities[2].avgPriceM2)}.`
            : "",
        expensiveCities
            ? `Najdroższym miastem pod względem cen mieszkań jest ${expensiveCities[0].city}. Na kolejnych miejscach plasują się: ${expensiveCities[1].city}, ${expensiveCities[2].city} i ${expensiveCities[3].city}.`
            : ""
    ];

    const genericFaq: IFaqQuestion[] = [
        {
            name: "Ile kosztuje średnio metr kwadratowy mieszkania w Polsce?",
            answer: answers[0],
            answer_text: answers[0]
        },
        {
            name: "Gdzie są najtańsze mieszkania w Polsce?",
            answer: answers[1],
            answer_text: answers[1]
        },
        {
            name: "Gdzie są najdroższe mieszkania w Polsce?",
            answer: answers[2],
            answer_text: answers[2]
        }
    ];

    return (
        <section className={sectionStyle}>
            <PricesHubViewSectionTracker sectionName="faq" />

            <Container maxWidthVariant="lg">
                <FaqSection faqContent={faq} genericFaqTitle="Pytania o ceny mieszkań w Polsce" genericQuestions={genericFaq} titleAlign="center" />
            </Container>
        </section>
    );
};

const sectionStyle = css({
    pt: 6,
    pb: 6,

    md: {
        pt: 9,
        pb: 9
    }
});
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {FaqSection, IFaqQuestion} from "@pg-mono/faq";
import {monthWhenVerbose, priceFormat, priceM2Format} from "@pg-mono/string-utils";

import {IRPStore} from "../../../../app/rp_reducer";
import {calculateAvgPrices} from "../../utils/calculate_avg_prices";
import {cityNameWhere, cityPronounWhere} from "../../utils/city_name_declination_utils";
import {getCitiesData} from "../../utils/get_cities_data";
import {calculatePercent, getPercentMeaning, getPercentMoreLess} from "../../utils/percents_handling_helpers";
import {PricesHubViewSectionTracker} from "./PricesHubViewSectionTracker";

// SEO manages the hub FAQ in admin (FAQ category assigned to this page's URL, fetched by fetchFaqListAtRoute),
// on top of the generic nationwide price questions also shown on the legacy general prices page.
export const PricesHubFaq = () => {
    const faq = useSelector((store: IRPStore) => store.faq.data);
    const citiesSummaryData = getCitiesData();

    const cheapestCities = citiesSummaryData && [...citiesSummaryData].sort((prev, next) => prev.avgPriceM2 - next.avgPriceM2);
    const expensiveCities = citiesSummaryData && [...citiesSummaryData].sort((prev, next) => next.avgPriceM2 - prev.avgPriceM2);
    const date = new Date((citiesSummaryData && citiesSummaryData[0].date) || "");
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const {generalAvgPrice, generalAvgM2Price, generalOldAvgPrice, generalOldAvgM2Price} = calculateAvgPrices(citiesSummaryData);
    const priceM2Percent = calculatePercent(generalOldAvgM2Price, generalAvgM2Price);
    const pricePercent = calculatePercent(generalOldAvgPrice, generalAvgPrice);

    const answers = [
        `W ${monthWhenVerbose(month)} ${year} średnia cena za m² wynosi ${priceM2Format(generalAvgM2Price)}. To o ${Math.abs(priceM2Percent)}% ${getPercentMoreLess(priceM2Percent)} niż w ubiegłym roku. Średnia ofertowa cena mieszkania w Polsce wynosi aktualnie ${priceFormat(generalAvgPrice)}, to oznacza ${getPercentMeaning(pricePercent)} o ${Math.abs(pricePercent)}% rok do roku.`,
        cheapestCities
            ? `Patrząc na miasta wojewódzkie, najtańsze mieszkania znajdziemy ${cityPronounWhere(cheapestCities[0].city)} ${cityNameWhere(cheapestCities[0].city)}, ${cityNameWhere(cheapestCities[1].city)} i ${cityNameWhere(cheapestCities[2].city)}. Ceny mieszkań wynoszą tu odpowiednio ${priceM2Format(cheapestCities[0].avgPriceM2)}, ${priceM2Format(cheapestCities[1].avgPriceM2)} oraz ${priceM2Format(cheapestCities[2].avgPriceM2)}.`
            : "",
        expensiveCities
            ? `Najdroższym miastem pod względem cen mieszkań jest ${expensiveCities[0].city}. Na kolejnych miejscach plasują się: ${expensiveCities[1].city}, ${expensiveCities[2].city} i ${expensiveCities[3].city}.`
            : ""
    ];

    const genericFaq: IFaqQuestion[] = [
        {
            name: "Ile kosztuje średnio metr kwadratowy mieszkania w Polsce?",
            answer: answers[0],
            answer_text: answers[0]
        },
        {
            name: "Gdzie są najtańsze mieszkania w Polsce?",
            answer: answers[1],
            answer_text: answers[1]
        },
        {
            name: "Gdzie są najdroższe mieszkania w Polsce?",
            answer: answers[2],
            answer_text: answers[2]
        }
    ];

    return (
        <section className={sectionStyle}>
            <PricesHubViewSectionTracker sectionName="faq" />

            <Container maxWidthVariant="lg">
                <FaqSection faqContent={faq} genericFaqTitle="Pytania o ceny mieszkań w Polsce" genericQuestions={genericFaq} titleAlign="center" />
            </Container>
        </section>
    );
};

const sectionStyle = css({
    pt: 6,
    pb: 6,

    md: {
        pt: 9,
        pb: 9
    }
});
